import axios from "axios";

export const read = async (skip,query,batas,thisCompany) => {
    if(batas === "Yes"){
        console.log(thisCompany)
        try{
            return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listCompanySpecific?skip=${skip}&query=${query}&thisCompany=${thisCompany}`,{
            })
        } catch(error){
            throw new Error(error);
        }
    }else{
    try{
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listCompany?skip=${skip}&query=${query}`,{
        })
    } catch(error){
        throw new Error(error);
    }
}
}